import { BimLimitedCostCalcMethodEnum, BimLimitedCostTypeEnum } from 'gql/graphql';

export type LimitType = { id: number; label: string; type: BimLimitedCostTypeEnum };

export type ItemGetKey = { id: number | string; label: string; type?: string };

export type TypeItem = {
    id: BimLimitedCostCalcMethodEnum;
    label: string;
    disabled?: boolean;
};

export const bimLimitedCostCalcMethods: TypeItem[] = [
    {
        id: BimLimitedCostCalcMethodEnum.IgnoreCustomerMtr,
        label: 'Не учитывать',
    },
    {
        id: BimLimitedCostCalcMethodEnum.TakeCustomerMtr,
        label: 'Учитывать',
    },
];

export const labelLimitedCost = {
    [BimLimitedCostTypeEnum.ProvidingWorkCondition]: 'Обеспечение нормальных условий труда',
    [BimLimitedCostTypeEnum.Snowfighting]: 'Снегоборьба',
    [BimLimitedCostTypeEnum.TemporaryConstruction]: 'Временные здания и сооружения',
    [BimLimitedCostTypeEnum.WinterPriceRising]: 'Зимнее удорожание',
    [BimLimitedCostTypeEnum.SalarySupplementWorkingFarNorth]:
        'Надбавка к заработной плате за стаж работы в районе Крайнего Севера',
    [BimLimitedCostTypeEnum.SalarySupplementWorkingFarNorthEquatedAreas]:
        'Надбавка к заработной плате за стаж работы в местностях, приравненных к районам - Крайнего Севера',
    [BimLimitedCostTypeEnum.ShiftMethodOrganizationCost]: 'Затраты на организацию работ вахтовым методом',
    [BimLimitedCostTypeEnum.MaterialsTransportationExtraCost]: 'Затраты на дополнительную транспортировку материалов',
};

export const fotEnabledLimitedCostTypes = [
    BimLimitedCostTypeEnum.SalarySupplementWorkingFarNorth,
    BimLimitedCostTypeEnum.SalarySupplementWorkingFarNorthEquatedAreas,
];

export const getLimitedCostRateValueDecimalScale = (type: BimLimitedCostTypeEnum) => {
    if (type === BimLimitedCostTypeEnum.ShiftMethodOrganizationCost) {
        return 5;
    }

    return 3;
};

export const typesLimitedCost: LimitType[] = [
    {
        id: 1,
        label: labelLimitedCost[BimLimitedCostTypeEnum.ProvidingWorkCondition],
        type: BimLimitedCostTypeEnum.ProvidingWorkCondition,
    },
    {
        id: 2,
        label: labelLimitedCost[BimLimitedCostTypeEnum.Snowfighting],
        type: BimLimitedCostTypeEnum.Snowfighting,
    },
    {
        id: 3,
        label: labelLimitedCost[BimLimitedCostTypeEnum.TemporaryConstruction],
        type: BimLimitedCostTypeEnum.TemporaryConstruction,
    },
    {
        id: 4,
        label: labelLimitedCost[BimLimitedCostTypeEnum.WinterPriceRising],
        type: BimLimitedCostTypeEnum.WinterPriceRising,
    },
    {
        id: 5,
        label: labelLimitedCost[BimLimitedCostTypeEnum.SalarySupplementWorkingFarNorth],
        type: BimLimitedCostTypeEnum.SalarySupplementWorkingFarNorth,
    },
    {
        id: 6,
        label: labelLimitedCost[BimLimitedCostTypeEnum.SalarySupplementWorkingFarNorthEquatedAreas],
        type: BimLimitedCostTypeEnum.SalarySupplementWorkingFarNorthEquatedAreas,
    },
    {
        id: 7,
        label: labelLimitedCost[BimLimitedCostTypeEnum.ShiftMethodOrganizationCost],
        type: BimLimitedCostTypeEnum.ShiftMethodOrganizationCost,
    },
    {
        id: 8,
        label: labelLimitedCost[BimLimitedCostTypeEnum.MaterialsTransportationExtraCost],
        type: BimLimitedCostTypeEnum.MaterialsTransportationExtraCost,
    },
];

export const hiddenTooltipKey = 'hidden-tooltip';
export const selectedTabTooltipKey = 'selected-tab-tooltip';
export const selectedSubTabTooltipKey = 'selected-sub-tab-tooltip';
